import React, { useEffect, useRef, useState } from 'react';

import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { templates } from 'api/endpoints/template';
import Button from 'components/Button';
import Input from 'components/Input';
import TitleInput from 'components/TitleInput';
import { ENUM_TYPE_CREATE_OPTIONS } from 'constants/enum';
import { TEXT_COMMON, TEXT_CREATE_SURVEY } from 'constants/string/texts';
import AppRoutes from 'routes/routes';
import { setOpenCreateOptions } from 'store/actions/survey';

const CreateOptions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openCreateOptions } = useSelector((state) => state.survey);
  const modalRef = useRef(null);

  const [templateList, setTemplateList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [typeSurvey] = useState(null);

  const closeModal = () => {
    dispatch(
      setOpenCreateOptions({
        isOpen: false,
      })
    );
    setTemplateList([]);
    setSelectedItem(null);
  };

  const onConfirm = async () => {
    if (selectedItem === ENUM_TYPE_CREATE_OPTIONS.CHILD_OTHER) {
      closeModal();
      navigate(`${AppRoutes.surveyCreate}`, { state: { period_type: typeSurvey } });
    } else {
      closeModal();
      navigate(`${AppRoutes.surveyTemplateFn(templateList[0].id)}`);
    }
  };

  const getSurveyTemplate = async () => {
    const result = await templates();
    if (result.data.length > 0) {
      setTemplateList(result.data);
    }
  };

  useEffect(() => {
    if (openCreateOptions.isOpen) {
      getSurveyTemplate();
    }
  }, [openCreateOptions]);

  useEffect(() => {
    if (openCreateOptions.isOpen) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('h-screen');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    }
  }, [openCreateOptions]);

  const clickBackdrop = () => {
    modalRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  if (!openCreateOptions.isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-50">
      <div onClick={clickBackdrop} className="fixed inset-0 backdrop" />
      <div ref={modalRef} className="bg-white rounded-sm shadow-lg relative w-112 modal-content">
        <div className="flex-between-center px-6 py-4 ">
          <p className="font-bold">{TEXT_CREATE_SURVEY.CREATE_OPTIONS_TITLE}</p>
        </div>
        <div className="p-3 relative">
          <div className="absolute top-0 left-0 w-full border-t border-white-720 h-0.25"></div>
          <div className="max-h-138 w-full overflow-y-auto p-3 grid grid-cols-1">
            <div className="h-8">
              <TitleInput text={TEXT_CREATE_SURVEY.CREATE_OPTIONS} required className="!my-0" />
            </div>
            {templateList.length > 0 && (
              <div className="mt-2">
                <Input
                  onChange={() => setSelectedItem(ENUM_TYPE_CREATE_OPTIONS.CHILD_5_YEAR_OLD_CHECKUP)}
                  checked={selectedItem === ENUM_TYPE_CREATE_OPTIONS.CHILD_5_YEAR_OLD_CHECKUP}
                  type="radio-cus"
                  text={`${TEXT_COMMON.FV_TEMPLATE}${templateList[0]?.title}` || TEXT_CREATE_SURVEY.CHILD_5_YEAR_OLD_CHECKUP}
                  name="create-options"
                  id="child-5-year-old-checkup"
                />
                <p className="text-sm text-secondary-354 mt-1 h-5.75">
                  {TEXT_CREATE_SURVEY.CHILD_5_YEAR_OLD_CHECKUP_DESCRIPTION.replace(
                    '{name_survey}',
                    `${TEXT_COMMON.FV_TEMPLATE}${templateList[0]?.title}` || TEXT_CREATE_SURVEY.CHILD_5_YEAR_OLD_CHECKUP
                  )}
                </p>
              </div>
            )}
            <div className="mt-4">
              <Input
                onChange={() => setSelectedItem(ENUM_TYPE_CREATE_OPTIONS.CHILD_OTHER)}
                checked={selectedItem === ENUM_TYPE_CREATE_OPTIONS.CHILD_OTHER}
                type="radio-cus"
                text={TEXT_CREATE_SURVEY.CUSTOM_SURVEY}
                name="create-options"
                id="child-other"
              />
            </div>
          </div>
        </div>
        <div className="h-16 border-t border-white-720 flex-end-center gap-2 py-4 px-6">
          <Button className="h-8 text-sm w-25.5" text={TEXT_COMMON.CANCEL_TEXT} color="outline" onClick={closeModal} />
          {selectedItem ? (
            <Button className="h-8 text-sm w-34" text={TEXT_CREATE_SURVEY.BUTTON_CREATE_OPTIONS} color="primary" onClick={onConfirm} />
          ) : (
            <Button
              className="h-8 text-sm w-34 border-gray-651 bg-white-795 !text-black/25 cursor-not-allowed"
              color="outline"
              text={TEXT_CREATE_SURVEY.BUTTON_CREATE_OPTIONS}
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default React.memo(CreateOptions);
